module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAABA0lEQVQokdWSPU7DQBCFP0yoKblCxA2osnJFhXIDanep4qTanQ4ukDqcIBINaS0h0aTmHjRIhuJRMLb8k4iaV+2b+Z52NLtnKSW6ijHeA49AaWZP3V42AAtgC1wBW/dj2Bsb+tr0AiklJBX61ZekvZ/37iWpSCkxBO8kLdwv3LcBJNUN6Le0sPsmUGfAHJiZ2TNH5PUZMJ+Y2csxaBB4G63uL/1HeBJjvAE+zOz9FBRjvAYuM6ACDjHG/ASYAwegQlLpL/YpKR88d+51SSqbj7TqBHZ+3nXAVUqJ8xACVVW9hhBq4BaY+gRT4AJYm9lDbxteWA9GbsHR6ryxBL6BZRcE+AHBK/pwQuuJVwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-touch.png
// module id = 336
// module chunks = 0